<div class="m-kpi" [ngClass]="'h-100 m-kpi--' + tone" *ngIf="isModern; else classicCard">

  <div class="m-kpi__head">
    <span class="m-kpi__icon"><i class="{{ icon }}"></i></span>
    <span class="m-kpi__label">{{ label }}</span>
    <button type="button" class="m-kpi__action" *ngIf="actionIcon" [title]="actionTitle || ''"
            [attr.aria-label]="actionTitle" (click)="onAction($event)">
      <i [ngClass]="actionIcon"></i>
    </button>
  </div>

  <ng-container *ngIf="!loading; else skeleton">
    <div class="m-kpi__value">{{ value }}</div>

    <div class="m-kpi__extras" *ngIf="extras?.length">
      <span *ngFor="let extra of extras" class="m-kpi__extra">
        <span class="m-kpi__extra-label">{{ extra.label }}</span>
        <span class="m-kpi__extra-value" [class.is-up]="extra.tone === 'success'"
              [class.is-down]="extra.tone === 'danger'">{{ extra.value }}</span>
      </span>
    </div>

    <div class="m-kpi__foot" *ngIf="delta !== null && delta !== undefined || comparison">
      <span class="m-kpi__delta" *ngIf="delta !== null && delta !== undefined"
            [class.is-up]="isPositive" [class.is-down]="!isPositive">
        <i class="bx" [ngClass]="isPositive ? 'bx-up-arrow-alt' : 'bx-down-arrow-alt'"></i>
        {{ deltaLabel }}
      </span>
      <span class="m-kpi__comparison" *ngIf="comparison">{{ comparison }}</span>
    </div>
  </ng-container>

  <ng-template #skeleton>
    <div class="m-kpi__skeleton"></div>
    <div class="m-kpi__skeleton m-kpi__skeleton--sm"></div>
  </ng-template>

</div>

<!-- Klasik tema: Skote mini-stats-wid kartı (Bootstrap/Skote sınıflarıyla, ek stil yok).
     Üst bölüm: etiket, değer ve açıklama solda, simge sağda. Ek değerler altta tam genişlikte,
     her biri ayrı satırda (etiket solda, tutar sağda) — uzun tutarlar satır kırmasın. -->
<ng-template #classicCard>
  <div class="card mini-stats-wid h-100 mb-0 position-relative">
    <!-- Eylem düğmesi kartın sağ üst köşesinde; simgenin üstünde kalır. -->
    <button type="button" class="btn btn-primary btn-sm rounded-circle p-0 position-absolute"
            style="top: 8px; right: 8px; width: 22px; height: 22px; line-height: 1; z-index: 1;"
            *ngIf="actionIcon" [title]="actionTitle || ''" [attr.aria-label]="actionTitle"
            (click)="onAction($event)">
      <i class="font-size-12" [ngClass]="actionIcon"></i>
    </button>

    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1 me-3" style="min-width: 0;">
          <p class="text-muted fw-medium mb-2">{{ label }}</p>

          <ng-container *ngIf="!loading; else classicLoading">
            <h4 class="mb-0">{{ value }}</h4>

            <p class="small mb-0 mt-1" *ngIf="delta !== null && delta !== undefined || comparison">
              <span class="badge me-1" *ngIf="delta !== null && delta !== undefined"
                    [ngClass]="isPositive ? 'badge-soft-success' : 'badge-soft-danger'">
                <i class="bx" [ngClass]="isPositive ? 'bx-up-arrow-alt' : 'bx-down-arrow-alt'"></i>{{ deltaLabel }}
              </span>
              <span class="text-muted" *ngIf="comparison">{{ comparison }}</span>
            </p>
          </ng-container>

          <ng-template #classicLoading>
            <h4 class="mb-0"><span class="spinner-border spinner-border-sm text-muted" role="status"></span></h4>
          </ng-template>
        </div>

        <div class="flex-shrink-0">
          <div class="mini-stat-icon avatar-sm rounded-circle">
            <span class="avatar-title rounded-circle" [ngClass]="'bg-' + classicTone">
              <i class="font-size-24" [ngClass]="icon"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="border-top mt-3 pt-2" *ngIf="!loading && extras?.length">
        <div class="d-flex justify-content-between gap-2 small" *ngFor="let extra of extras; let first = first"
             [class.mt-1]="!first">
          <span class="text-muted">{{ extra.label }}</span>
          <span class="fw-medium text-end" [ngClass]="extra.tone ? 'text-' + extra.tone : 'text-body'">{{ extra.value }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
